import {Pipe, PipeTransform} from '@angular/core';
import {UmpireArticle} from '@tisa-group/models';
import {TisaArticle} from '@tisa-group/client-ui/models';
import {SimpleImageVariantPipe} from '@tisa-group/core';

@Pipe({
  name: 'adapterArticle',
  standalone: false,
})
export class AdapterArticlePipe implements PipeTransform {
  constructor(private readonly _simpleImageVariant: SimpleImageVariantPipe) {}

  transform(article: UmpireArticle): TisaArticle {
    return {
      id: article.id,
      slug: article.id,
      title: article.title,
      publishedAt: article.publication_time as string,
      category: {
        id: article.publication_category.id as string,
        name: article.publication_category.name as string,
        slug: article.publication_category.type as string,
      },
      image: this._simpleImageVariant.transform(article.image, 1200, 800, 50),
    };
  }
}
